import DefaultView from 'nette-back-module/js/views/back.default'
import merge from 'lodash/merge'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import UploaderMixin from 'nette-back-module/js/mixins/uploader'

export default merge({
  mixins: [
    UploaderMixin
  ],
  computed: {
    uploaderOptions () {
      return {
        url: this.$presenter.uploadUrl,
        exts: ['jpg', 'jpeg', 'png', 'bmp', 'tiff', 'nef', 'raw', 'svg', 'gif'],
        maxUploadFiles: 50,
        onFileUploadDone: this.fileUploadDone,
        onProgress: this.progress,
        onError: this.error,
        name: 'qqfile'
      }
    }
  },
  methods: {
    selectObject (image) {
      this.$store.dispatch('mediaGallery/setSelected', image)
      if (this.$store.state.mediaGallery.isMultiple === false && this._snippetName === 'modalmedia') {
        NetteAjax.ext('vue-modal').$vfm.hide('modalmedia')
      }
    },
    hideModal () {
      NetteAjax.ext('vue-modal').$vfm.hide('modalmedia')
    },
    fileUploadDone(data) {
      if (data.error) {
        this.error(data.error)
        return
      }
      this.mediaObjectsComputed = [data].concat([...this.mediaObjectsComputed])
      this.uploadError = false
    }
  }
}, DefaultView)
